import { Tabs } from 'expo-router';
import { Activity, CalendarDays, Home, MessageSquare, UserRound } from 'lucide-react-native';
import { STUDENT_MAIN_TABS, type StudentMainTabName } from '../../constants/expoRoutes';
import { tokens } from '../../theme/tokens';

const tabIcons: Record<StudentMainTabName, typeof Home> = {
  index: Home,
  'ai-assistant': MessageSquare,
  'study-plan': CalendarDays,
  'learning-analysis': Activity,
  profile: UserRound,
};

const fallbackStudentTabOptions: Record<StudentMainTabName, { title: string }> = {
  index: { title: '学习' },
  'ai-assistant': { title: '问答' },
  'study-plan': { title: '计划' },
  'learning-analysis': { title: '轨迹' },
  profile: { title: '我的' },
};

const getStudentTabOptions = (name: StudentMainTabName) => {
  const tab = STUDENT_MAIN_TABS.find((item) => item.name === name);
  const Icon = tabIcons[name];

  return {
    title: tab?.title ?? fallbackStudentTabOptions[name].title,
    tabBarIcon: ({ color, size }: { color: string; size: number }) => (
      <Icon color={color} size={size} />
    ),
  };
};

export default function StudentTabsLayout() {
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: tokens.colors.primary,
        tabBarInactiveTintColor: tokens.colors.textMuted,
        tabBarStyle: {
          alignSelf: 'center',
          width: '100%',
          maxWidth: tokens.component.studentShell.maxWidth,
          height: tokens.component.studentShell.tabBarHeight,
          minHeight: tokens.component.studentShell.tabBarHeight,
          marginBottom: tokens.component.studentShell.bottomOffset,
          paddingTop: tokens.spacing.xs,
          paddingBottom: tokens.spacing.sm,
          backgroundColor: tokens.colors.surface,
          borderTopColor: tokens.colors.border,
          borderBottomLeftRadius: tokens.component.studentShell.tabBarRadius,
          borderBottomRightRadius: tokens.component.studentShell.tabBarRadius,
        },
        tabBarLabelStyle: {
          fontSize: tokens.fontSize.xs,
          fontWeight: tokens.fontWeight.semibold,
        },
      }}
    >
      <Tabs.Screen name="index" options={getStudentTabOptions('index')} />
      <Tabs.Screen name="ai-assistant" options={getStudentTabOptions('ai-assistant')} />
      <Tabs.Screen name="study-plan" options={getStudentTabOptions('study-plan')} />
      <Tabs.Screen
        name="learning-analysis"
        options={getStudentTabOptions('learning-analysis')}
      />
      <Tabs.Screen name="profile" options={getStudentTabOptions('profile')} />
      <Tabs.Screen
        name="wrong-questions"
        options={{
          href: null,
        }}
      />
    </Tabs>
  );
}
